module.exports = __webpack_public_path__ + "img/img-purple_bg.323245fa.svg";